var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-block logout-btn",class:{
        'btn-secondary-simple' : _vm.$isWealthTime && !_vm.isWhitelabeled,
        'btn-primary' : _vm.$isWealthTime && _vm.isWhitelabeled,
        'btn-secondary m-0' : !_vm.$isWealthTime           
    },attrs:{"id":"logout-button","type":"button","data-test-id":"logout-btn"},on:{"click":_vm.logout}},[_vm._v(" Log out ")])}
var staticRenderFns = []

export { render, staticRenderFns }